<template>
  <div>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="str-loarding">
                <span class="kei"></span>
                <span class="san"></span>
                <span class="chu"></span>
            </div>
            <p>処理中</p>
        </div>
    </div>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

export default {
    name:"ModalLoadingShort",
    methods: {
        ...mapActions('view', [
          'shortSpinShow',
          'shortSpinHide'
        ])
    },
}
</script>

<style scoped>
div.modal-dialog{
    display: block;
    width: 100%;
    height: 100%;
    min-height: 80vh;
    padding: 0;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.2);
    position: fixed;
    overflow: scroll;
    top: 0;
    z-index: 99999;
}
.modal-content{
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    width: 250px;
    height: 250px;
    max-height: 250px;
    margin:  65px auto 0;
    padding: 1em 4em;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0 5px 15px 2px rgba(0, 0, 0, 0.5);
}
.icon-spin{
    width: 250px;
    padding: 20px;
}
.str-loarding {
  display: flex;
  align-content: center;
  height: 100px;
}
.str-loarding span{
    display: inline-block;
    width: 12px;
    height: 24px;
    margin: 0 10px;
    text-align: center;
    background-color: #41B8D4;
    border-radius: 0;
    animation: key1 .3s ease infinite alternate;
}
.str-loarding span:nth-child(0) {
  animation-delay: .1s;
}
.str-loarding span:nth-child(1) {
  animation-delay: .2s;
}
.str-loarding span:nth-child(2) {
  animation-delay: .3s;
}

@keyframes key1{
  0% { 
    background-color: #0443A8;
    transform:scaleY(1);
    }
  100% {
    background-color: #41B8D4;
    transform:scaleY(3);
    }
}
 
</style>


